import { Box, Card, Typography, Widget } from '@scope/scope-one-ui/core';
import { COLORS, SIZES } from '@scope/scope-one-ui/theme';
import styled from 'styled-components';
import { ScrollableAreaProps } from './PortfolioSummary.d';

export const SummaryCard = styled(Card)`
  margin-top: ${SIZES.spacing(4)};
  margin-bottom: ${SIZES.spacing(3)};
  display: flex;
  justify-content: space-between;
  align-content: center;
`;

export const SummaryTitle = styled(Typography)`
  line-height: ${SIZES.spacing(4)};
`;

export const WidgetsWrapper = styled(Box)`
  display: grid;
  grid-column: 1/3;
  grid-gap: ${SIZES.spacing(4)};
  grid-template-columns: 1fr 1fr 1fr;
`;

export const WidgetStyled = styled(Widget)`
  height: ${SIZES.spacing(52)};
`;

export const ScrollableArea = styled(Box)<ScrollableAreaProps>`
  display: flex;
  flex-direction: column;
  overflow-y: ${({ showScroll }) => (showScroll ? 'scroll' : 'hidden')};
`;

export const WidgetItem = styled(Box)`
  cursor: pointer;
  transition: 0.2s ease-out;
  border-left: 0.25rem solid ${COLORS.background.main};

  &:hover {
    color: ${COLORS.primary.hover};
    background-color: ${COLORS.secondary.hover};
    border-left: 0.25rem solid ${COLORS.primary.main};
  }
`;

export const WidgetItemSubtitleDescription = styled(Typography)`
  margin-right: ${SIZES.spacing(0.25)};
`;

export const TileRow = styled(Box)`
  height: 100%;
`;

export const TileNumber = styled(Typography)`
  color: ${COLORS.typography.label};
  font-size: ${SIZES.spacing(5.25)};
  margin-bottom: ${SIZES.spacing(1)};
`;

export const IconWrapper = styled(Box)`
  height: 100%;
  margin-right: ${SIZES.spacing(2)};
  align-items: end;
  display: none;
`;

export const Tile = styled(Box)`
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding-top: ${SIZES.spacing(3.25)};
  padding-left: ${SIZES.spacing(3.25)};
  padding-bottom: ${SIZES.spacing(2)};
  color: ${COLORS.typography.main};
  display: flex;
  justify-content: space-between;
  transition: 0.2s ease-out;

  &:hover {
    background-color: ${COLORS.secondary.hover};
    color: ${COLORS.primary.hover};
  }

  &:hover ${TileNumber} {
    color: ${COLORS.primary.hover};
  }
  &:hover ${IconWrapper} {
    display: flex;
  }
`;

export const ThreeDotsTile = styled(Box)`
  width: 100%;
  height: 100%;
  padding-top: ${SIZES.spacing(3.25)};
  padding-left: ${SIZES.spacing(3.25)};
`;

export const EntitiesTile = styled(Tile)`
  border-right: 1px solid ${COLORS.border.main};
  border-bottom: 1px solid ${COLORS.border.main};
`;

export const InstrumentsTile = styled(Tile)`
  border-bottom: 1px solid ${COLORS.border.main};
`;
export const FundsTile = styled(Tile)`
  border-right: 1px solid ${COLORS.border.main};
`;
